import { render, staticRenderFns } from "./DadosObito.vue?vue&type=template&id=09751a07&scoped=true&"
import script from "./DadosObito.vue?vue&type=script&lang=js&"
export * from "./DadosObito.vue?vue&type=script&lang=js&"
import style0 from "./DadosObito.vue?vue&type=style&index=0&id=09751a07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09751a07",
  null
  
)

export default component.exports